import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatTableModule } from '@angular/material/table';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';
import { AccionesDialog } from '@models/base/identificadores.model';
import { CreateCasosUsoRequest } from '@models/seguridad/casosUso/createCasosUsoRequest.model';
import { MenuDto } from '@models/seguridad/menu/menuDto.model';
import { CasoUsoService } from '@services/casoUso/casoUso.service';
import { MenuService } from '@services/menu/menu.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';

import { ButtonCancelDialogComponent } from 'src/app/component/button-cancel-dialog/button-cancel-dialog.component';
import { ButtonCloseDialogComponent } from 'src/app/component/button-close-dialog/button-close-dialog.component';
import { isFalsy } from 'utility-types';

@Component({
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatCardModule, MatIconModule, MatButtonModule, MatDividerModule, NgxSpinnerModule, MatTableModule, MatSliderModule, MatSlideToggleModule, CommonModule, MatMenuModule, MatDialogModule, MatDatepickerModule, MatExpansionModule, AppRolesDirective, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatSelectModule, MatOptionModule, MatButtonModule, MatIconModule, ButtonCancelDialogComponent,
    NgxSpinnerModule],
  selector: 'app-dialog-create-caso-uso',
  templateUrl: './dialog-create-caso-uso.component.html',
  styleUrls: ['./dialog-create-caso-uso.component.css']
})
export class DialogCreateCasoUsoComponent implements OnInit {

  formBuilder = new FormBuilder;
  form: any;
  menus!: MenuDto[];
  get f() { return this.form.controls; }
  constructor(
    public dialogRef: MatDialogRef<DialogCreateCasoUsoComponent>,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private casoUsoService: CasoUsoService,
    private menuService: MenuService
  ) {

    this.form = this.formBuilder.group({
      Descripcion: ["", Validators.compose([Validators.required,])],
      Icono: ["", Validators.compose([Validators.required,])],
      Path: ["", Validators.compose([Validators.required])],
      Menu: [""],
    })
  }

  ngOnInit(): void {
    this.getAllMenus()
  }
  getAllMenus() {
    this.spinner.show("spBusquedaMenu")
    this.menuService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spBusquedaMenu")
          this.menus = data
        },
        error => {
          this.spinner.hide("spBusquedaMenu")
          this.snackBar.showError(error, "Error");
        }
      )
  }


  doAction() {

    let createCasosUsoRequest: CreateCasosUsoRequest = new CreateCasosUsoRequest
    createCasosUsoRequest.descripcion = this.form.controls["Descripcion"].value
    createCasosUsoRequest.icon = this.form.controls["Icono"].value.toLowerCase()
    createCasosUsoRequest.path = this.form.controls["Path"].value.toLowerCase()
    createCasosUsoRequest.idMenu = isFalsy(this.form.controls["Menu"].value) ? null : this.form.controls["Menu"].value
    this.create(createCasosUsoRequest)
  }

  closeDialog() {
    this.dialogRef.close({ event: AccionesDialog.Cancelar });
  }

  create(createCasosUsoRequest: CreateCasosUsoRequest) {
    this.spinner.show("spCrearCasoUso")
    this.casoUsoService.create(createCasosUsoRequest)
      .subscribe(
        data => {
          this.spinner.hide("spCrearCasoUso")
          this.snackBar.showSuccess("Registro agregado correctamente.", "Exito");
          this.dialogRef.close({ event: AccionesDialog.Agregar });
        },
        error => {
          this.spinner.hide("spCrearCasoUso")
          this.snackBar.showError(error, "Error");
        }
      )
  }

  isFalsy(valor: any) {
    return isFalsy(valor)
  }

  trackByItems(index: number, item: any): any { return item; }
}
